module.exports = __webpack_public_path__ + "img/Selection.4eef7241.svg";